import { HIJACKED_USER_ID_QUERY_ARG } from './Auth/constants';
import { hijackedUserIdVar, tokenDataVar } from './Auth/vars';

const STAFF_SESSION_KEY = 'tt_staff_analytics_session';

function markGa4InternalTraffic() {
  try {
    window.gtag?.('set', { traffic_type: 'internal' });
  } catch {
    // A blocked tag must not change staff detection.
  }
}

/** Staff browser consent and attribution must never identify a viewed customer. */
export function isStaffAnalyticsSession(): boolean {
  const roles = tokenDataVar()?.roles ?? [];
  const tokenTaxStaff =
    roles.includes('tokentax-admin') ||
    roles.includes('tokentax-dev') ||
    /^\/tokentax-admin(?:\/|$)/.test(window.location.pathname);
  // Org owners and admins also view clients, but their traffic is customer
  // traffic. ga4Bootstrap.js applies the same rule before the bundle loads.
  if (tokenTaxStaff) markGa4InternalTraffic();

  const staffSession =
    tokenTaxStaff ||
    Boolean(hijackedUserIdVar()) ||
    Boolean(new URLSearchParams(window.location.search).get(HIJACKED_USER_ID_QUERY_ARG));

  // Rudder can retain the last customer's identity after staff leave their view.
  // Keep this tab excluded after navigation or logout as well.
  try {
    if (staffSession) sessionStorage.setItem(STAFF_SESSION_KEY, 'true');
    return staffSession || sessionStorage.getItem(STAFF_SESSION_KEY) === 'true';
  } catch {
    return staffSession;
  }
}
